import React from "react";
import "../Public/css/CustomLoader.css";

const CustomLoader = ({ active, children }) => {
  return (
    <div className="loader-wrapper">
      {children}

      {active && (
        <div className="loader-overlay">
          <div className="spinner" />
        </div>
      )}
    </div>
  );
};

export default CustomLoader;
